import { render, staticRenderFns } from "./PushExtraCell.vue?vue&type=template&id=8021f6d2&"
import script from "./PushExtraCell.vue?vue&type=script&lang=js&"
export * from "./PushExtraCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports